import React from 'react';

// Lines join adjacent supplied observations only. Explicit missing days break the line.
export const RosterSparkline = ({ series = [], testId, label }) => {
  const valid = series.filter(point => Number.isFinite(point.value));
  if (valid.length < 2) return null;
  const values = valid.map(point => point.value);
  const min = Math.min(...values), range = Math.max(...values) - min;
  const dates = series.map(point => Date.parse(point.date));
  const first = Math.min(...dates), duration = Math.max(...dates) - first;
  const segments = [];
  let segment = [];
  series.forEach((point, i) => {
    if (!Number.isFinite(point.value)) {
      if (segment.length) segments.push(segment);
      segment = [];
    } else {
      const x = 3 + (duration ? (dates[i] - first) / duration : i / (series.length - 1)) * 74;
      const y = range ? 25 - (point.value - min) / range * 20 : 15;
      segment.push([x, y]);
    }
  });
  if (segment.length) segments.push(segment);
  return <svg viewBox="0 0 80 30" className="roster-sparkline" role="img" aria-label={label} data-testid={testId}>
    <title>{label}</title>
    {segments.map((points, i) => <g key={i}>
      {points.length > 1 && <polyline points={points.map(p => p.join(',')).join(' ')} fill="none" stroke="currentColor" strokeWidth="1.5" />}
      {points.map(([x, y], j) => <circle key={j} cx={x} cy={y} r="1.7" fill="currentColor" />)}
    </g>)}
  </svg>;
};